import { ISignalP1 } from "../../utils/signal/ISignalP1";
import { Accessory } from "./Accessory";
import { IAccessorySetting } from "../../config/IProjectSettings";

export class AccessoryIcon
{

	private _id: string;
	private _enabled: boolean = false;
	private _element : HTMLElement;
	private _icon: HTMLElement;
	private _moveIcon: HTMLElement;

	private _moveIconClickSignal: ISignalP1<AccessoryIcon>;

	private _accessory : Accessory;

	constructor(iconId:string, accessory:Accessory, moveIconClickSignal: ISignalP1<AccessoryIcon>)
	{
		this._id = iconId;
		this._element = document.getElementById(iconId);
		this._icon = <HTMLElement>this._element.querySelector(".icon");
		this._moveIcon = <HTMLElement>this._element.querySelector(".move_icon");

		this._accessory = accessory;

		this._icon.addEventListener("click", this.onClick);

		this._moveIconClickSignal = moveIconClickSignal;
		this._moveIcon.addEventListener("click", this.onMoveIconClick);
	}

	private onClick = (event: MouseEvent) =>
	{
		if (this._enabled)
		{
			this.disable();
		}
		else
		{
			this.enable();
		}
	};

	private enable()
	{
		this._element.classList.add("selected");
		this._enabled = true;
		this._accessory.show();
	}

	private disable()
	{
		this._element.classList.remove("selected");
		this._enabled = false;
		this._accessory.hide();
	}

	private onMoveIconClick = () =>
	{
		this._moveIconClickSignal.dispatch(this);

		this._moveIcon.classList.add("placing");
	}

	public stopPlacing()
	{
		this._moveIcon.classList.remove("placing");
	}

	public enableMoveIcon()
	{
		this._moveIcon.classList.remove("disabled");
	}

	public disableMoveIcon()
	{
		this._moveIcon.classList.add("disabled");
	}

	public get moveIconClickSignal()
	{
		return this._moveIconClickSignal;
	}

	public get accessory()
	{
		return this._accessory;
	}

	public resetSettings()
	{
		this.disable();
	}
	public setSetting(setting: IAccessorySetting): void
	{
		if (setting.enabled)
		{
			this.enable();
		}
		else
		{
			this.disable();
		}
		this._accessory.setPosition(setting.position);
	}

	public getSetting(): IAccessorySetting
	{
		return {
			id: this._id,
			enabled: this._enabled,
			modelPath: "",
			rotation: this._accessory.rotation,
			position: this._accessory.position
		}
	}

	public get id()
	{
		return this._id;
	}
}